import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    getWebRoles({
      commit
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/webRole",
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            commit("updateWebRoles", {
              webRoles: response.data.entity
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    getCatalogs({
      commit
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/webRole/getAllCatalogs",
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            commit("updateCatalogs", {
              catalogs: response.data.entity
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    createRole({
      commit
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/webRole",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data.status) {
            commit("addWebRole", {
              webRole: response.data.entity
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateRoles({
      commit
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/webRole",
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            commit("updateWebRoles", {
              webRoles: response.data.entity
            }, {
              root: true
            })
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    deleteRole(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/webRole/delcat?id="+id,
          method: "DELETE"
        }).then(response => {
            resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}